var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"type-subscript-wrap",style:((_vm.subscriptStyle))},[((_vm.cardData.period))?_c('div',{staticClass:"period-wrap",style:((_vm.periodBg))},[_vm._v(_vm._s(_vm.cardData.period))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }